<p-dialog header="Subscrever" blockScroll="true" [(visible)]="showModal" maximizable="true" [style]="{width: '500px'}"
  (onHide)="closeModal()">

  <small>Plano</small>
  <h5 class="text-title">{{plano.nome}}</h5>

  <p class="title text-secondary mb-1">Para subscrever ao plano deverá seguir os seguintes procedimentos:</p>

  <div class="row mb-2">
    <div class=" col-12 step my-3">
      <span style="font-size: 1.8rem; color: blue; margin-bottom: 8px; display: inline-block;">1 - <i
          class="p-2 bg-light la la-hand-pointer" style="font-size: 1.8rem;"></i></span>
      <h5 class="text-subtitle">Selecionar o plano</h5>
      <p>Após efectuar a transferência bancária, selecione o plano desejado.</p>
    </div>
    <div class=" col-12 step my-3">
      <span style="font-size: 1.8rem; color: brown; margin-bottom: 8px; display: inline-block;">2 - <i
          class="p-2 bg-light la la-credit-card" style="font-size: 1.8rem;"></i></span>
      <h5 class="text-subtitle">Efectuar a tranferência bancária</h5>
      <p class="ps-3">IBAN: <strong>0044 0000 6841 2577 1017 2</strong> </p>
      <p class="ps-3">Nome: <strong>Nilton Staloni Henriques de Matos</strong> </p>
      <p class="ps-3">Valor: <strong>{{plano.preco | currency: '(AOA)'}}</strong> </p>
    </div>
    <div class=" col-12 step my-3">
      <span style="font-size: 1.8rem; color: green; margin-bottom: 8px; display: inline-block;">3 - <i
          class="p-2 bg-light la la-check" style="font-size: 1.8rem;"></i></span>
      <h5 class="text-subtitle">Enviar comprovativo</h5>
      <p>Após a tranferência efectuada navegar até <strong><a [routerLink]="['/conta']">
            Conta,</a></strong> selecionar a opção 'Subscrições' e submeter o comprovativo de
        pagamento para o plano selecionado
      </p>
    </div>
  </div>

  <p-footer>
    <div class="actions row">
      <div class="col-md-6 d-flex items-align-center">
        <button class="btn btn-transparent w-100" (click)="closeModal()">
          Cancelar
        </button>
      </div>
      <div class="col-md-6 d-flex items-align-center">
        <button pButton type="button" icon="la la-check" label="Confirmar a subscrição"
          class="p-button p-button-primary w-100" (click)="subscrever()">
        </button>

      </div>
    </div>
  </p-footer>

</p-dialog>
